module.exports = __webpack_public_path__ + "maldives.svg?c7689c57520befe512773040714b78cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/maldives.svg
// module id = 223
// module chunks = 10